import Widget from 'Components/Common/Widget/Widget'
import RequestedGroupTable from 'Components/GroupRequest/RequestGroupTable'
import RequestedUsersTable from 'Components/WithdrawalRequest/RequestedUsersTable'
import React, { useState } from 'react'
import { GiMoneyStack } from 'react-icons/gi'
import { TbSquareRoundedCheck, TbSquareRoundedX } from 'react-icons/tb'

function GroupRequest() {
    const [count,setCount]=useState({
        total:0,
        approved:0,
        rejected:0
    })
    return (
        <>
            <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
                <Widget
                    icon={<GiMoneyStack className="h-6 w-6" />}
                    title={"Total Request Raised"}
                    subtitle={count.total}
                />
                <Widget
                    icon={<TbSquareRoundedCheck className="h-6 w-6" />}
                    title={"Total Approved Request"}
                    subtitle={count.approved}
                />
                <Widget
                    icon={<TbSquareRoundedX className="h-6 w-6" />}
                    title={"Total Rejected Request"}
                    subtitle={count.rejected}
                />
            </div>

            <RequestedGroupTable setCount={setCount}/>
        </>
    )
}

export default GroupRequest